import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import Loader from '../../../components/utils/Loader';
import InfoBox from '../../../components/utils/InfoBox';
import { isEmpty } from 'lodash';
import { MEASURES_RAW } from '../constansts';
import { getReceipesByIngredient } from '../../../action/recipes';
import moment from 'moment';
import { fetchRawsList } from '../../../action/raw';
import { parseNumToFixed } from '../../../utils/common';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

export function UsedReceipeSemi() {
    const dispatch = useDispatch();
    const detail = useSelector(fromStore.detailRawSelector);
    const loaderRaws = useSelector(fromStore.loaderRawsSelector);
    const loaderReceipe = useSelector(fromStore.loaderRecipeRawSelector);
    const loading = loaderReceipe || loaderRaws;
    const id = detail ? detail.id : null;
    const raws = useSelector(fromStore.rawListSelector);

    useEffect(() => {
        if (id && !detail.recipesSemi) dispatch(getReceipesByIngredient(id, 'semi'));
        isEmpty(raws) && dispatch(fetchRawsList(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, id, detail.recipesSemi]);

    const renderTable = (recipes) => (
        <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
            <table className="kt-datatable__table" style={{ width: '100%' }}>
                <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span>Наименование</span>
                    </th>
                    <th width="auto" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'left' }}></span>
                    </th>
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'center' }}>Дата</span>
                    </th>
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'center' }}>Количество</span>
                    </th>
                </tr>
                </thead>
                <tbody className="kt-datatable__body">
                {recipes.map((item) => {
                    const ingredient = item.ingredients.find((ingredient) => ingredient.id === detail.id);
                    const raw = raws.find((el) => el.id === item.productId);

                    return (
                    <tr key={item.id} className="kt-datatable__row">
                        <td width="145px" className="kt-datatable__cell">{raw.name || ''}</td>
                        <td align="left" width="auto" className="kt-datatable__cell">{MEASURES_RAW[ingredient.measure] || ''}</td>
                        <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                            <span style={{ textAlign: 'center' }}>{moment(item.startDate).format('DD.MM.YYYY HH:mm')}</span>
                        </th>
                        <td align="center" width="145px" className="kt-datatable__cell">{parseNumToFixed(ingredient.quantity.default, 3)}</td>
                    </tr>
                )})}
                </tbody>
            </table>
        </div>
    );
    
    const renderContentForActiveDate = () => {
        return (
            <div>
                {renderTable(detail.recipesSemi)}
            </div>
        );
    };

    return (
        <>
            {loading ? (
                <div style={styles.loading}><Loader /></div>
            ) : (
                <>
                    <div className="kt-portlet__body" style={{ minHeight: '350px', padding: '1rem' }}>
                        {(!isEmpty(detail.recipesSemi) && !isEmpty(raws)) ? (
                            renderContentForActiveDate()
                        ) : (
                            <div style={{ padding: '20px' }}>
                                <InfoBox
                                    title="Рецепты полуфабрикатов"
                                    subtitle="Для полуфабриката нет рецептов"
                                />
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
